/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `purchase` - 크레딧 구매
 * `spend` - 사용
 * `bonus` - 보너스 지급
 * `refund` - 환불
 * `monthly_grant` - 월 무료 지급
 */
export type TransactionTypeEnum =
  (typeof TransactionTypeEnum)[keyof typeof TransactionTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionTypeEnum = {
  purchase: "purchase",
  spend: "spend",
  bonus: "bonus",
  refund: "refund",
  monthly_grant: "monthly_grant",
} as const;
